import React from 'react';
import Avatar from '../../Avatar/Avatar';
import DownloadAttachment from '../DownloadAttachment/DownloadAttachment';
import { convertTime } from 'src/helpers/time';

export interface ChatMessageData {
  sentBy: string;
  sentByName: string;
  sentByImage: string | null;
  receivedOn: string;
  message: string;
  fileURL: string | null;
  fileName: string | null;
}

interface ChatMessageProps {
  message: ChatMessageData;
  currentUserId: string;
  canStartVideoChat: boolean;
  onStartVideoChat: (message: ChatMessageData) => void;
}

const ChatMessage = ({
  message,
  currentUserId,
  canStartVideoChat,
  onStartVideoChat,
}: ChatMessageProps) => {
  const isOwnMessage = message.sentBy === currentUserId;
  const sentTime = convertTime(message.receivedOn, 'LT');
  const sentDate = convertTime(message.receivedOn, 'date');
  const attachmentName = message.fileName || '';
  const bubbleAlign = isOwnMessage ? 'right' : 'left';

  if (isOwnMessage) {
    return (
      <>
        <div className="message-right">
          <div className="message-content">
            <div className="message-time">{sentTime}</div>
            {message.message && (
              <div className="message-text">{message.message}</div>
            )}
          </div>
        </div>
        {message.fileURL && (
          <DownloadAttachment
            fileURL={message.fileURL}
            fileName={attachmentName}
            align={bubbleAlign}
          />
        )}
      </>
    );
  }

  return (
    <>
      <div className="message-left">
        <div className="message-avatar">
          <Avatar size="chat" url={message.sentByImage} />
          {canStartVideoChat && (
            <div
              className="video-chat-button"
              onClick={() => onStartVideoChat(message)}
            >
              <img src={'/assets/icon-chat.png'} alt="start video chat" />
            </div>
          )}
        </div>
        <div className="message-content">
          <div className="message-time">
            <span>{message.sentByName}</span> {sentDate}
          </div>
          {message.message && (
            <div className="message-text">{message.message}</div>
          )}
        </div>
      </div>
      {message.fileURL && (
        <DownloadAttachment
          fileURL={message.fileURL}
          fileName={attachmentName}
          align={bubbleAlign}
        />
      )}
    </>
  );
};

export default ChatMessage;